import {Graphics, InteractionEvent, Sprite, Texture} from 'pixi.js';
import {TextureUrlLoader} from '../../../../../../utils/TextureUrlLoader';
import {StaticData} from '../../../../../../data/StaticData';
import {Back, gsap} from 'gsap';

export class LeaveButton extends Sprite
{
    private graphicsBg: Graphics;
    private icon: Sprite | undefined;
    private appearTween: gsap.core.Tween | undefined;

    constructor(private onClick: Function) {
        super();

        this.graphicsBg = new Graphics();
        this.graphicsBg.interactive = true;
        this.addChild(this.graphicsBg);

        this.draw();

        this.graphicsBg.on('pointerdown', this.onPointerDown, this);
        this.loadIcon();
        this.pivot.x = 20;
    }

    destroy(): void {
        this.graphicsBg.off('pointerdown', this.onPointerDown, this);
        super.destroy({children: true});
    }

    appear(value: boolean = true): void {
        this.appearTween && this.appearTween.pause();
        this.appearTween = gsap.to(this.pivot, {
            x: value ? -StaticData.videoSeatLeaveButtonAppearWidth : 20,
            duration: .3,
            ease: value ? Back.easeOut : Back.easeIn
        });
    }

    private onPointerDown(e: InteractionEvent): void {
        this.onClick();
    }

    private draw() {
        this.graphicsBg.clear();
        this.graphicsBg.beginFill(StaticData.videoSeatLeaveButtonColor);
        this.graphicsBg.drawRoundedRect(0, 0, StaticData.videoSeatLeaveButtonWidth, StaticData.videoSeatLeaveButtonHeight, StaticData.videoSeatLeaveButtonRadius);
        this.graphicsBg.endFill();
    }

    private async loadIcon() {
        let iconTexture: Texture | null = await TextureUrlLoader.load('/images/video_seats/leave.svg');
        this.icon = new Sprite(iconTexture!);
        this.icon.anchor.set(.5, .5);
        this.addChild(this.icon).interactive = false;
        this.icon.position.set(StaticData.videoSeatLeaveButtonWidth - StaticData.videoSeatLeaveButtonHeight / 2 + 3, StaticData.videoSeatLeaveButtonHeight / 2);
    }
}
